/* eslint-disable */
import 'modernizr';
// import LazySizes from 'lazysizes';
/* eslint-enable */

import { onDocumentReady } from './utils';

// Components
import Links from './components/links';
import InView from './components/in-view';
import SectionTriggers from './components/section-triggers';
import Cursor from './components/cursor';
import FitSVGText from './components/fit-svg-text';
import Parallax from './components/parallax';
import DisableHoverOnScroll from './components/disable-hover-while-scrolling';
import Form from './components/form';
import MouseCarousel from './components/mouse-carousel';

import TransformationAnim from './components/transformation';

onDocumentReady(() => {
  document.body.classList.add('document-ready');

  new Links();
  new DisableHoverOnScroll();
  new TransformationAnim();

  if (document.querySelector('.js-contact-form')) {
    new Form();
  }

  if (document.querySelectorAll('.js-in-view').length) {
    new InView();
  }
  if (document.querySelectorAll('.js-fit-text').length) {
    new FitSVGText();
  }

  if (document.querySelectorAll('.js-page-section').length) {
    new SectionTriggers();
  }

  if (document.querySelectorAll('.js-cursor').length) {
    new Cursor();
  }

  if (document.querySelector('.js-mouse-carousel')) {
    new MouseCarousel();
  }

  if (document.querySelectorAll('.js-parallax')) {
    document.querySelectorAll('.js-parallax').forEach(dom => {
      new Parallax(dom);
    });
  }

  if (document.querySelector('.js-hang-punc')) {
    import(/* webpackChunkName: "hang-punctuation" */ './components/hang-punctuation').then(
      module => {
        const HangPunctuation = module.default;
        new HangPunctuation();
      },
    );
  }
});
